import React from "react";
import LimitTemplate from "../Common";
import limitsApi from "../../../api/limits";
import reports from "../../../api/reports";

export const DesktopLimit = () => (
  <LimitTemplate
    header="Desktop limits"
    requestApi={limitsApi.getLimitsListDesktop}
    requestReport={reports.requestLimitsListDesktop}
  />
);
